import { render, staticRenderFns } from "./shipmentContractAdd.vue?vue&type=template&id=38cff9cc&scoped=true"
import script from "./shipmentContractAdd.vue?vue&type=script&lang=js"
export * from "./shipmentContractAdd.vue?vue&type=script&lang=js"
import style0 from "./shipmentContractAdd.vue?vue&type=style&index=0&id=38cff9cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cff9cc",
  null
  
)

export default component.exports